<template>
  <div id="ResultPlayer">
    <div id="playerBox" class="player-box flex" :class="{free: !player, 'not-free': player, looser: looser, winner: !looser}">
      <div id="name-box">
        <h3 class="name">{{ player ? player.name : 'LIBERO' }}</h3>
      </div>
      <div v-if="player">
        <img id="user-image" alt="user" :src="require('../assets/user.jpg')" width="100" height="100" :class="{'looser-img': looser}"/>
      </div>
      <div class="current-score">
        <h3>Punti:{{ player.points }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ResultPlayer",
  components: {
  },
  props: {
    player: {
      type: Object,
      required: false
    },
    looser: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters({ 
      user: "user/user"
    })
  },
};
</script>
<style scoped>
#playerBox {
  border-radius: 10px;
  padding: 10px 15px;
  background-color:antiquewhite;
  color: black;
  border: 5px solid black;
}
.winner {
  width: 150px;
}
.looser {
  width: 100px;
  font-size: 10px;
}
.looser-img {
  width: 50px;
  height: 50px;
}
#name-box {
  margin-right: 1em;
}
#player-info{
  display: flex;
  flex-direction: column;
}
.flex {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.name {
  margin-left: 0.5em;
}
.current-score {
  margin-top: 10px;
}
@media all and (max-height: 500px) {
  #ResultPlayer {
    font-size: xx-small;
  }
  #user-image {
    width: 40px;
    height: 40px;
  }
  #playerBox {
    padding: 5px 5px;
  }
}
</style>
